import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { DocumentoDetalleService } from 'src/app/services/documento-detalle.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ProductoService } from 'src/app/services/producto.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { GuiaDespachoCabeceraComponent } from '../guia-despacho-cabecera/guia-despacho-cabecera.component';

@Component({
  selector: 'app-guia-despacho-detalles',
  templateUrl: './guia-despacho-detalles.component.html',
  styleUrls: ['./guia-despacho-detalles.component.scss'],
  providers: [SecurityService],
})
export class GuiaDespachoDetallesComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @Input() cabeceraComponent: GuiaDespachoCabeceraComponent;
  @Output() onProductAdded: EventEmitter<'LIBRE' | 'NORMAL'> = new EventEmitter<'LIBRE' | 'NORMAL'>();

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  cliente: any = null;
  private sucursal: any = null;
  detalleDocumento: Array<any> = [];
  totales: any = null;

  // Form
  formDetails: FormGroup;
  productoSeleccionado: any = null;
  optionsFormato: any = [];
  optionsFormatoProductoLibre: Array<any> = [{ value: 'UNID', label: 'Unidad' }];

  // Utils
  private log: any;

  // Getters
  get disableEliminar() {
    return this.detalleDocumento.filter((p) => p.additionalInfo.checked).length === 0;
  }

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private formatoProductoService: FormatoProductosService,
    private tipoDocumentoService: TipoDTEService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private productoService: ProductoService,
    private documentoService: DocumentoService,
    private formValidatorsService: FormValidatorsService,
    private documentoDetalleService: DocumentoDetalleService
  ) {
    this.log = this.clog.log('GUIA-DESPACHO-DETALLE');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.createForms();
    this.formChangesSubscriptions();
  }

  createForms() {
    this.formDetails = this.fb.group({
      esProductoLibre: [false],
      productoLibre: this.fb.group({
        codigo: [''],
        descripcion: ['', [Validators.required]],
        cantidad: [null, [Validators.required, Validators.min(1)]],
        formato: ['UNID', [Validators.required]],
        precioUnitario: [0, [Validators.required, Validators.min(1)]],
      }),
      productoExistente: this.fb.group({
        codigoProducto: ['', [Validators.required, Validators.min(1)]],
        formato: [null, [Validators.required]],
        cantidad: [0, [Validators.required, Validators.min(1)]],
        precioUnitario: [null, [Validators.required]],
        // descuento: this.fb.group({
        //   porcentaje: [null],
        //   monto: [null],
        // }),
        // recargo: this.fb.group({
        //   porcentaje: [null],
        //   monto: [null],
        // })
      }),
    });

    this.formDetails.get('productoLibre.codigo').disable();
  }

  formChangesSubscriptions() {
    this.formDetails
      .get('productoExistente.codigoProducto')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((codigo: string) => {
        if (!codigo) return;
        this.modalSeleccionarProducto.searchBySKU(codigo);
        this.modalSeleccionarProducto.clearLast();
      });

    // formato
    this.formDetails.get('productoExistente.formato').valueChanges.subscribe((formato) => this.handleFormatoChange(formato));
  }

  // formChangesSubscriptions() {
  //   // DESCUENTOS Y RECARGOS | INICIO
  //   // toggle descuentos y recargos | descuento | porcentaje/pesos clp
  //   this.formDetails.get('productoExistente.descuento.porcentaje').valueChanges.subscribe(value => {
  //     this.togglePorcentajeMontoValuesAndValidators(value, "descuento.porcentaje", "descuento.monto")
  //     // if (value && this.headerData.clienteSeleccionado) {
  //     //   const { descuento_maximo } = this.headerData.clienteSeleccionado
  //     //   let descuentoValidators = [
  //     //     Validators.required,
  //     //     Validators.min(1)
  //     //   ]
  //     //   if (descuento_maximo > 0) {
  //     //     descuentoValidators.push(Validators.max(descuento_maximo))
  //     //   }
  //     //   this.formDetails.get('productoExistente.descuento.porcentaje').setValidators(descuentoValidators)
  //     // }
  //   })
  //   this.formDetails.get('productoExistente.descuento.monto').valueChanges.subscribe(value => {
  //     this.togglePorcentajeMontoValuesAndValidators(value, "descuento.monto", "descuento.porcentaje")
  //   })

  //   // toggle descuentos y recargos | recargo | porcentaje/pesos clp
  //   this.formDetails.get('productoExistente.recargo.porcentaje').valueChanges.subscribe(value => {
  //     this.togglePorcentajeMontoValuesAndValidators(value, "recargo.porcentaje", "recargo.monto")
  //   })
  //   this.formDetails.get('productoExistente.recargo.monto').valueChanges.subscribe(value => {
  //     this.togglePorcentajeMontoValuesAndValidators(value, "recargo.monto", "recargo.porcentaje")
  //   })
  //   // DESCUENTOS Y RECARGOS | FIN

  //   this.formDetails.get('productoExistente.codigoProducto').valueChanges
  //     .pipe(filter(Boolean), debounceTime(1000))
  //     .subscribe((codigo: string) => {
  //       this.log('codigoProductoItem valueChanges', codigo)
  //       this.modalSeleccionarProducto.searchBySKU(codigo)
  //     })
  // }

  // private togglePorcentajeMontoValuesAndValidators(value, currentFormControlName, previousFormControlName) {
  //   if (value) {
  //     // remove validators
  //     this.formDetails.get(previousFormControlName).setValidators(null)
  //     this.formDetails.get(previousFormControlName).setValue(null)

  //     // set validator
  //     this.formDetails.get(currentFormControlName).setValidators([Validators.required, Validators.min(1)])
  //   }
  // }

  // Método consumido desde parent
  handleClienteChange(cliente) {
    this.cliente = cliente;
    this.getPrecioUnitario();
  }

  // Método consumido desde parent
  handleSucursalChange(sucursal) {
    this.sucursal = sucursal;
  }

  abrirModalSeleccionarProducto() {
    this.modalSeleccionarProducto.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      showInforAdicionar: true,
      defaultUnidadNegocio: 0 /**sin agregar unidad de negocio */,
    });

    // this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado;
    this.cleanProductoSeleccionadoRelateds();
    this.formDetails.get('productoExistente.codigoProducto').setValue(_productoSeleccionado.sku);
    this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
      this.optionsFormato = respuesta.registros.map((formato) => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }));
      this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('productoExistente.formato'), this.optionsFormato);
    });
  }

  cleanProductoSeleccionadoRelateds() {
    this.optionsFormato = [];
    this.formDetails.get('productoExistente.formato').setValue(null);
    this.formDetails.get('productoExistente.formato').markAsPristine();
    this.formDetails.get('productoExistente.formato').markAsUntouched();
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null;
    this.optionsFormato = [];
    this.formDetails.get('productoExistente.formato').setValue(null);
  }

  handleFormatoChange(formato) {
    // Limpiar
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);

    if (!formato) return;
    if (!this.productoSeleccionado) return;
    if (!this.cliente) {
      this.toastService.warning('Seleccione cliente para obtener precio unitario');
      return;
    }
    this.getPrecioUnitario();
  }

  getPrecioUnitario() {
    // Limpiar
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);

    if (!this.cliente || !this.productoSeleccionado || !this.formDetails.get('productoExistente.formato').value) return;

    const formatoSeleccionado = this.formDetails.get('productoExistente.formato').value;
    const inputParams: any = {
      empresa_rut: this.rutEmpresa,
      producto_codigo: this.productoSeleccionado.codigo,
      formato_codigo: this.optionsFormato.filter((opt) => opt.value === formatoSeleccionado)[0].formato_codigo,
      lista_precio_codigo: this.cliente.lista_precio_codigo,
      tipo_producto_codigo: this.productoSeleccionado.tipo_producto_codigo,
    };

    this.productoService.GetPrecioUnitario(inputParams, (respuesta) => {
      let precio_unitario = null;
      if (respuesta) precio_unitario = respuesta.precio_unitario;
      this.formDetails.get('productoExistente.precioUnitario').setValue(precio_unitario);
    });
  }

  private copyAndCleanDetalledocumento(detalleDocumento) {
    let _detalledocumento = _.cloneDeep(detalleDocumento);
    _detalledocumento.map((p) => {
      delete p.additionalInfo;
      delete p.aplicacion_descuento;
      delete p.aplicacion_recargo;
    });
    return _detalledocumento;
  }

  agregarProducto(type: 'NORMAL' | 'LIBRE') {
    switch (type) {
      case 'NORMAL':
        this.agregarProductoNormal();
        break;
      case 'LIBRE':
        this.agregarProductoLibre();
        break;
      default:
        break;
    }
  }

  private agregarProductoNormal() {
    this.formValidatorsService.validateAllFormFields(this.formDetails.get('productoExistente') as FormGroup);
    if (!this.formDetails.get('productoExistente').valid) return;

    let breakProcess: boolean = false;
    if (!this.cliente) {
      this.toastService.warning('Seleccione cliente');
      breakProcess = true;
    }
    if (!this.sucursal) {
      this.toastService.warning('Seleccione sucursal');
      breakProcess = true;
    }

    if (breakProcess) return;

    if (this.formDetails.get('productoExistente.precioUnitario').value === '0' || this.formDetails.get('productoExistente.precioUnitario').value === 0) {
      this.toastService.error(`El Producto indicado no posee Precio en Lista`);
      return;
    }

    if (this.formDetails.get('productoExistente.cantidad').value > 1 && this.formDetails.get('productoExistente.formato').value.includes('MED')) {
      this.toastService.error('La cantidad debe ser 1 cuando el formato es MED');
      return;
    }

    const headerData = this.cabeceraComponent.getHeaderData();
    const { cliente, form, sucursal, vendedor, codigo_bodega_entrada, codigo_bodega_salida, observaciones, tipo_traslado_codigo } = headerData;
    const formatoSeleccionado = this.formDetails.get('productoExistente.formato').value;
    const inputParams = {
      entidad_detalleDTO: {
        tipo_dte_codigo: 1, // De donde obtengo este valor
        producto_codigo: this.productoSeleccionado.codigo,
        sku: this.productoSeleccionado.sku,
        formato_codigo: this.optionsFormato.filter((opt) => opt.value === formatoSeleccionado)[0].formato_codigo,
        formato_nombre: this.optionsFormato.filter((opt) => opt.value === formatoSeleccionado)[0].formato_nombre,
        descripcion_producto: this.productoSeleccionado.descripcion,
        cantidad: Number(this.formDetails.get('productoExistente.cantidad').value),
        precio_unitario: Number(this.formDetails.get('productoExistente.precioUnitario').value),
        es_exento: this.productoSeleccionado.es_exento,
      },
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: this.sucursal.codigo, // Está correcto?
          lista_precio_codigo: this.cliente.lista_precio_codigo,
          aplica_rebaja: form.rebajaStock,
          tipo_traslado_codigo: tipo_traslado_codigo,
          codigo_bodega_origen: codigo_bodega_salida,
        },
        detalleDocumento: this.copyAndCleanDetalledocumento(this.detalleDocumento),
      },
    };
    this.queryAgregarDetalles(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      registros.map((detalle, index) => {
        delete detalle.__typename;
        if (detalle.atributos)
          detalle.atributos.map((attr) => {
            delete attr.__typename;
          });
        detalle.additionalInfo = {
          checked: false,
          index,
        };
      });
      this.detalleDocumento = registros;

      this.toastService.success('Producto agregado');
      this.onProductAdded.emit('NORMAL');
      this.limpiarDataAddProducto();
      this.ObtenerTotales();
    });
  }

  private agregarProductoLibre() {
    this.formValidatorsService.validateAllFormFields(this.formDetails.get('productoLibre') as FormGroup);
    if (!this.formDetails.get('productoLibre').valid) return;

    let breakProcess: boolean = false;
    if (!this.cliente) {
      this.toastService.warning('Seleccione cliente');
      breakProcess = true;
    }
    if (!this.sucursal) {
      this.toastService.warning('Seleccione sucursal');
      breakProcess = true;
    }

    if (this.formDetails.get('productoLibre.cantidad').value > 1 && this.formDetails.get('productoLibre.formato').value.includes('MED')) {
      this.toastService.error('La cantidad debe ser 1 cuando el formato es MED');
      return;
    }

    if (breakProcess) return;

    const formatoSeleccionado = this.formDetails.get('productoLibre.formato').value;
    const formatoLibre = this.optionsFormatoProductoLibre.find((opt) => opt.value === formatoSeleccionado);
    const formatoCodigo = formatoSeleccionado;
    const formatoNombre = formatoLibre ? formatoLibre.label : formatoSeleccionado;
    const inputParams = {
      entidad_detalleDTO: {
        tipo_dte_codigo: 1,
        producto_codigo: 0,
        sku: '0',
        formato_codigo: formatoCodigo,
        formato_nombre: formatoNombre,
        descripcion_producto: this.formDetails.get('productoLibre.descripcion').value,
        cantidad: this.formDetails.get('productoLibre.cantidad').value,
        precio_unitario: this.formDetails.get('productoLibre.precioUnitario').value,
        descuento_linea_pesos: 0,
        descuento_linea_porcentaje: 0,
        recargo_linea_porcentaje: 0,
        recargo_linea_pesos: 0,
        es_exento: true,
        es_afecto_reglas_comerciales: false,
      },
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: this.sucursal.codigo, // Está correcto?
          lista_precio_codigo: this.cliente.lista_precio_codigo,
        },
        detalleDocumento: this.copyAndCleanDetalledocumento(this.detalleDocumento),
      },
    };
    this.documentoDetalleService.agregarDetalleProductoLibreGuiaDespacho(inputParams, ({ respuesta, mensajes }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      registros.map((detalle, index) => {
        delete detalle.__typename;
        if (detalle.atributos)
          detalle.atributos.map((attr) => {
            delete attr.__typename;
          });
        detalle.additionalInfo = {
          checked: false,
          index,
        };
      });
      this.detalleDocumento = registros;

      this.toastService.success('Producto agregado');
      this.onProductAdded.emit('LIBRE');
      this.limpiarDataAddProducto();
      this.ObtenerTotales();
    });
  }

  queryAgregarDetalles(inputParams, callback) {
    const self = this;
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              agregarDetalleGuiaDespacho(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    aplicacion_descuento
                    aplicacion_recargo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { respuesta, mensajes } = response.data.documento_detalle.agregarDetalleGuiaDespacho;
        callback({ respuesta, mensajes });
      }
    );
  }

  limpiarDataAddProducto() {
    this.productoSeleccionado = null;
    this.optionsFormato = [];
    this.formDetails.get('productoExistente.codigoProducto').setValue(null);
    this.formDetails.get('productoExistente.formato').setValue(null);
    this.formDetails.get('productoExistente.cantidad').setValue(0);
    this.formDetails.get('productoExistente.precioUnitario').setValue(null);

    this.formDetails.get('productoExistente.codigoProducto').markAsPristine();
    this.formDetails.get('productoExistente.formato').markAsPristine();
    this.formDetails.get('productoExistente.cantidad').markAsPristine();
    this.formDetails.get('productoExistente.precioUnitario').markAsPristine();

    this.formDetails.get('productoExistente.codigoProducto').markAsUntouched();
    this.formDetails.get('productoExistente.formato').markAsUntouched();
    this.formDetails.get('productoExistente.cantidad').markAsUntouched();
    this.formDetails.get('productoExistente.precioUnitario').markAsUntouched();

    this.formValidatorsService.resetField(this.formDetails, 'productoLibre.codigo');
    this.formValidatorsService.resetField(this.formDetails, 'productoLibre.descripcion');
    this.formValidatorsService.resetField(this.formDetails, 'productoLibre.cantidad');
    this.formValidatorsService.resetField(this.formDetails, 'productoLibre.precioUnitario');
  }

  ObtenerTotales() {
    this.totales = null;

    const inputParams = {
      entidadDTO: {
        cabecera: {
          rut_emisor: this.rutEmpresa,
          sucursal_codigo: this.sucursalEmpresa,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: this.sucursal.codigo, // Está correcto?
          lista_precio_codigo: this.cliente.lista_precio_codigo,
          es_correcion_monto: false,
          es_nc: false,
        },
        descuentosGlobales: [],
        detalleDocumento: this.copyAndCleanDetalledocumento(this.detalleDocumento),
      },
    };

    this.documentoService.ObtenerTotalesDocumento(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.totales = respuesta;
    });
  }

  checkAllChange({ checked }) {
    this.detalleDocumento.forEach((detalle) => {
      detalle.additionalInfo.checked = checked;
    });
  }

  checkDetalle({ index }) {
    const selected = this.detalleDocumento.filter((p) => p.additionalInfo.index === index)[0];
    selected.additionalInfo.checked = !selected.additionalInfo.checked;
  }

  eliminarSeleccionados() {
    if (this.detalleDocumento.filter((p) => p.additionalInfo.checked).length === 0) {
      this.toastService.warning('Seleccione productos(s) para eliminar');
      return;
    }
    this.modalConfirm.show(() => {
      // this.detalleDocumento = this.detalleDocumento.filter(documento => !documento.additionalInfo.checked)
      const detalleDocumento = _.cloneDeep(this.detalleDocumento);
      detalleDocumento.map((documento) => {
        if (documento.additionalInfo.checked) documento.eliminar_linea = true;
        else documento.eliminar_linea = false;
        delete documento.additionalInfo;
      });

      const inputParams = {
        entidad_detalleDTO: {},
        entidadDTO: {
          cabecera: {
            rut_emisor: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            cliente_proveedor_rut: this.cliente.rut,
            direccion_codigo: this.sucursal.codigo, // Está correcto?
            lista_precio_codigo: this.cliente.lista_precio_codigo,
          },
          detalleDocumento,
        },
      };

      this.log('inputParams', JSON.stringify(inputParams));

      this.documentoDetalleService.eliminarDetalleProductoGuiaDespacho(inputParams, ({ respuesta, mensajes }) => {
        const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        const { registros } = respuesta;
        registros.map((detalle, index) => {
          delete detalle.__typename;
          if (detalle.atributos)
            detalle.atributos.map((attr) => {
              delete attr.__typename;
            });
          detalle.additionalInfo = {
            checked: false,
            index,
          };
        });
        this.detalleDocumento = registros;

        this.toastService.success('Producto agregado');

        this.limpiarDataAddProducto();
        this.ObtenerTotales();
      });
    });
  }

  getDetailsData() {
    return {
      detalleDocumento: this.copyAndCleanDetalledocumento(this.detalleDocumento),
      totales: this.totales,
    };
  }

  getProducts({ inputParams: modalInputParams, callback }) {
    const self = this;

    const { unidad_negocio_codigo } = this.cabeceraComponent.getHeaderData();

    this.log(modalInputParams);
    const inputParams = {
      empresa_rut: modalInputParams.empresa_rut,
      sucursal_codigo: modalInputParams.sucursal_codigo,
      sku: modalInputParams.sku,
      descripcion: modalInputParams.descripcion,
      tipobusquedad_afecto_exento: modalInputParams.tipobusquedad_afecto_exento,
      familia: modalInputParams.familia,
      rubro: modalInputParams.rubro,
      unidad_negocio_codigo: unidad_negocio_codigo,
      paginaActual: modalInputParams.paginaActual,
      cantidadRegistrosPorPagina: modalInputParams.cantidadRegistrosPorPagina,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.productoService.obtenerSegunFiltroProductosFacturables(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (!respuesta) {
        callback(new QueryResult(null, 0, 0, 0));
        return;
      }
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
    });
  }

  public clearForm() {
    this.cliente = null;
    this.sucursal = null;
    this.detalleDocumento = [];
    this.totales = null;

    // Form
    this.formValidatorsService.reset(this.formDetails);
    this.cleanProductoSeleccionadoRelateds();
    this.productoSeleccionado = null;
    this.formDetails.get('productoExistente.cantidad').setValue(0);
    this.formDetails.get('productoLibre.cantidad').setValue(0);
  }
}
